// src/services/widgetDataService.js
// Syncs app data to iOS Home Screen widgets via the WidgetDataPlugin

import { Capacitor } from '@capacitor/core';
import { registerPlugin } from '@capacitor/core';

const WidgetData = registerPlugin('WidgetData');

/**
 * Update widget data in the shared App Group container.
 * Call this whenever user_data is saved/loaded.
 * 
 * @param {Object} params
 * @param {string} params.firstName - User's first name
 * @param {number} params.netWorth - Total net worth
 * @param {number} params.assets - Total assets
 * @param {number} params.savingsInvestments - Total savings + investments
 * @param {number} params.budgetPercentLeft - Budget % remaining (0-100)
 * @param {number} params.budgetSpentPercent - Budget % spent, matching the Budget tab ring (uncapped)
 * @param {number} params.totalIncome - Monthly income
 * @param {number} params.totalSpent - Monthly spent
 * @param {number} params.totalSavings - Monthly saved/invested
 * @param {number} params.budgetAvailable - Budget available amount
 * @param {string} params.currentMonth - e.g. "March"
 * @param {number} params.currentYear - e.g. 2026
 * @param {string} params.theme - "pink", "blue", or "warm"
 * @param {string} params.currencySymbol - e.g. "$"
 */
export const updateWidgetData = async ({
  firstName = 'there',
  netWorth = 0,
  assets = 0,
  savingsInvestments = 0,
  budgetPercentLeft = 0,
  budgetSpentPercent = 0,
  totalIncome = 0,
  totalSpent = 0,
  totalSavings = 0,
  budgetAvailable = 0,
  currentMonth = '',
  currentYear = 2026,
  theme = 'pink',
  currencySymbol = '$',
  calendarData,
  fundsData,
  billsData,
  w2Data // w2_09
}) => {
  // Only run on native iOS
  if (Capacitor.getPlatform() !== 'ios') return;
  
  try {
    await WidgetData.updateWidgetData({
      firstName,
      netWorth,
      assets,
      savingsInvestments,
      budgetPercentLeft,
      budgetSpentPercent,
      totalIncome,
      totalSpent,
      totalSavings,
      budgetAvailable,
      currentMonth,
      currentYear,
      theme,
      currencySymbol,
      // Only sent by the main sync; other callers leave the saved calendar alone
      ...(calendarData ? { calendarData } : {}),
      ...(fundsData ? { fundsData } : {}),
      ...(billsData ? { billsData } : {}),
      ...(w2Data ? { w2Data } : {})
    });
    console.log('[WidgetData] Updated widget data successfully');
  } catch (err) {
    console.warn('[WidgetData] Failed to update widget data:', err);
  }
};
